export enum LengthUnit {
    CENTIMETER = 'cm',
    MILLIMETER = 'mm',
    INCHES = 'in',
    FEET = 'ft'
}
